import { render, staticRenderFns } from "./WAccountEdit.vue?vue&type=template&id=73fafa20&"
import script from "./WAccountEdit.vue?vue&type=script&lang=ts&"
export * from "./WAccountEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports